export default __webpack_public_path__ + "static/MediaMainBannerMobile-6bdcd63172a15451540bc3ff45cca884.webp";